import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";

import authAxios from "../../components/authAxios";

import Pagination from '@mui/material/Pagination';
import DashboardHeader from "../../components/DashboardHeader";
import AddIcon from '@mui/icons-material/Add';
import Fab from '@mui/material/Fab';
// import VisibilityOutlined from '@material-ui/icons/VisibilityOutlined';
import { VisibilityOutlined } from "@mui/icons-material";
import BorderColorSharpIcon from '@mui/icons-material/BorderColor';

import moment from 'moment';    

import Pillchip from "../../components/Pillchip";

// import PropertyEdit from "./PropertyEdit";
import EllipsisMenu from "../../components/EllipsisMenu";
import CustomSearchBar from "../../components/CustomSearchBar";


const Loans = () => {
    const [page, setPage] = useState(1);
    const [pagecount, setPageCount] = useState();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isNewModalOpen, setIsNewModalOpen] = useState(false);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);

    const navigate = useNavigate()
    const [searchText, setSearchText] = useState('');
    const [property, setProperty] = useState("")
    const [clientType, setClientType] = useState('');

    // const { data: clientProfile } = useQuery({
    //     queryKey: ['clientProfile'],
    //     queryFn: async () => {
    //       const response = await authAxios.get(`/clientprofiles/${localStorage.getItem('clientProfile')}`);
    //       setClientType(response.data.client_type)
    //       return response.data
    //     },
    // });

    const { data: loans } = useQuery({
        queryKey: ['loans', page, searchText],
        queryFn: async () => {
          const response = await authAxios.get(`/loans/loans/?page=${page}&search=${searchText}`);
          setPageCount(response.data.page_count)
          return response.data.results
        },
    });

    // const [isDrawerOpen, setIsDrawerOpen] = useState(false)

    // const handleDrawerOpen = () => {
    //     setIsDrawerOpen(true)
    // };
  
    // const handleDrawerClose = () => {
    //     setIsDrawerOpen(false)
    // };

    //Pagination
     const handlePageChange = (event, value) => {
        setPage(value);
    };

    const menuItems = (loan) => [
        {
            label: 'View',
            icon: <VisibilityOutlined />,
            onClick: () => {
                // Handle view action
                navigate(`/dashboard/loan/${loan.id}`)
            }
        },
        // {
        //     label: 'Edit',
        //     icon: <BorderColorSharpIcon />,
        //     onClick: () => {
        //         setProperty(property)
        //         // setIsModalOpen(true)
        //         setIsEditModalOpen(true)

        //     }
        // },
        // {
        //     label: 'Review',
        //     icon: <VisibilityOutlined />,
        //     onClick: () => {
        //         navigate(`/dashboard/property/${property.id}`)
        //     }
        // },
    ];


    return (
        <div className="dashboard-main">

            <section className="dashboard-content">
                <div className="dashboard-content-header-nav">
                
                    <DashboardHeader dashboardTitle="Loans" dashboardPreTitle="Loans" />
                    <div className="dashboard-content-header-nav-icons">
                        <CustomSearchBar 
                            searchText={searchText}
                            setSearchText={setSearchText}
                        />
                    </div>
                </div>

                <table className="styled-table">
                    <thead>
                        <tr >
                            <th>#</th>
                            <th>Reference</th>
                            {/* <th>Application</th> */}
                            <th>Application Date</th>
                            <th>Customer</th>
                            <th>Loan Type</th>
                            <th>Amount</th>
                            {/* <th>Term</th> */}
                            <th>Interest</th>
                            <th>Status</th>
                            <th></th>
                        </tr>
                    </thead>

                    {loans && loans.map(loan => (

                        <tbody key={loan.id}>
                            <tr>
                                <td>{loan.id}</td>
                                <td>{loan.lc_reference}</td>
                                {/* <td>{loan.application_id}</td> */}
                                <td>{moment(loan.application_date).format('DD-MM-YYYY')}</td>
                                <td>{loan.customer_name}</td>
                                <td>{loan.product_name}</td>
                                <td>{Number(loan.amount).toLocaleString()}</td>
                                <td>{new Intl.NumberFormat(undefined, { style: 'percent', minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(Number(loan.interest_rate))}</td>
                                {/* <td>{loan.term+' '+loan.term_unit_name}</td> */}
                                <td><Pillchip label={loan.status_name} /></td>
                                <td className='styled-table-menu'>
                                <EllipsisMenu items={menuItems(loan)} />
                            </td>
                            </tr>
                        </tbody>
                    ))}
                    

                </table>

                <Pagination 
                    className="custom-mui-pagination"
                    count={pagecount} 
                    page={page} 
                    onChange={handlePageChange} 
                />

                <Fab 
                    className="fab" 
                    color="primary" 
                    aria-label="add" 
                    onClick={()=>{
                        navigate('/dashboard/application-new') 
                        }   
                    }
                >
                    <AddIcon />
                </Fab>
                

            </section>
        </div>

    )
}
export default Loans